import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';
const CollapsibleJSONViewer = ({ data, className = '' }) => {
    const [rootExpanded, setRootExpanded] = useState(true);
    const [expanded, setExpanded] = useState(new Set());
    const toggleExpand = (path, isRoot) => {
        if (isRoot) {
            setRootExpanded(!rootExpanded);
            return;
        }
        const newExpanded = new Set(expanded);
        if (newExpanded.has(path)) {
            newExpanded.delete(path);
        }
        else {
            newExpanded.add(path);
        }
        setExpanded(newExpanded);
    };
    const RenderValue = ({ value, path = '', isLast = true, isRoot = false }) => {
        if (value === null)
            return _jsx("span", { className: "text-gray-500", children: "null" });
        if (typeof value === 'boolean')
            return _jsx("span", { className: "text-purple-600", children: value.toString() });
        if (typeof value === 'number')
            return _jsx("span", { className: "text-blue-600", children: value });
        if (typeof value === 'string')
            return _jsxs("span", { className: "text-green-600", children: ["\"", value, "\""] });
        const isArray = Array.isArray(value);
        const isExpanded = isRoot ? rootExpanded : expanded.has(path);
        if (isArray || typeof value === 'object') {
            const isEmpty = Object.keys(value).length === 0;
            if (isEmpty)
                return _jsx("span", { children: isArray ? '[]' : '{}' });
            return (_jsxs("div", { className: "ml-4", children: [_jsxs("div", { className: "inline-flex items-center cursor-pointer hover:bg-gray-100 rounded px-1", onClick: () => toggleExpand(path, isRoot), children: [isExpanded ? (_jsx(ChevronDown, { className: "w-4 h-4" })) : (_jsx(ChevronRight, { className: "w-4 h-4" })), _jsx("span", { className: "text-gray-800", children: isArray ? '[' : '{' }), !isExpanded && (_jsxs("span", { className: "text-gray-500 ml-1", children: [Object.keys(value).length, " items"] }))] }), isExpanded && (_jsx("div", { className: "ml-4", children: Object.entries(value).map(([key, val], index, arr) => (_jsxs("div", { className: "my-1", children: [_jsx("span", { className: "text-gray-800", children: isArray ? '' : `"${key}": ` }), _jsx(RenderValue, { value: val, path: `${path}-${key}`, isLast: index === arr.length - 1 }), !isLast && index < arr.length - 1 && _jsx("span", { children: "," })] }, `${path}-${key}`))) })), isExpanded && (_jsx("div", { className: "ml-0", children: isArray ? ']' : '}' }))] }));
        }
        return _jsx("span", { children: String(value) });
    };
    const parseAndRender = (jsonData) => {
        try {
            const parsed = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
            return _jsx(RenderValue, { value: parsed, isRoot: true });
        }
        catch (error) {
            return _jsx("div", { className: "text-red-500", children: "Invalid JSON" });
        }
    };
    return (_jsx("div", { className: `font-mono text-sm ${className}`, children: parseAndRender(data) }));
};
export default CollapsibleJSONViewer;
